import AppModules from "@/app/store/modules"
import toast from './toast'
import auth from './auth'
export default {
  toast,
  auth,
  ...AppModules
}
